const digits = [
  "null",
  "eins",
  "zwei",
  "drei",
  "vier",
  "fünf",
  "sechs",
  "sieben",
  "acht",
  "neun",
];

/** Spell five-digit postal codes, including leading zeros, only in spoken output. */
export function spokenPostalCodes(text: string): string {
  return text.replace(/\b\d{5}\b/g, (code, offset: number) => {
    // A five-digit fraction is not a postcode (e.g. 49.12345 or 9,12345).
    if (
      /\d[.,]$/.test(text.slice(0, offset)) ||
      /^[.,]\d/.test(text.slice(offset + 5))
    )
      return code;
    return [...code].map((digit) => digits[Number(digit)]).join(", ");
  });
}
